// extracted by mini-css-extract-plugin
module.exports = {"galleryItem":"galleryitem-module--galleryItem--1H_YR","galleryThumb":"galleryitem-module--galleryThumb--IJm3d"};